import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/password`;

export default {
  async changePassword(payload) {
    let apiUrl = store.state.countrySelected.api;
    payload.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/update?lang=${payload.lang}`, payload);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
